import { autoinject } from 'aurelia-framework';
import { BaseApiService } from './base-api-service';
import { AuthHttpClient } from './auth-http-client';
import { UserManualDto } from 'models/UserManual';

@autoinject
export class UserManualService extends BaseApiService<UserManualDto> {
  constructor(httpClient: AuthHttpClient) {
    super(httpClient, UserManualDto);
  }
}
